import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import VendorTable from 'components/vendor/VendorTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import { Tabs, Tab } from '@mui/material';

import VendorServices from 'services/VendorServices';
import VendorDrawer from 'components/drawer/VendorDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';
import { FiPlus } from 'react-icons/fi';
import Loader from 'components/form/Loader';
import sidebar from 'routes/sidebar';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import { FiRefreshCcw } from 'react-icons/fi';

const Vendor = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	// const {
	//   state: { adminInfo },
	// } = useContext(AdminContext);
	// const { data, loading, error } = useAsync(VendorServices.getAllVendor);
	const [status, setStatus] = useState('');
	const { toggleDrawer, isUpdate, functionLoading, setIsUpdate } =
		useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage, setItemsPerPage] = useState(100);
	const [tab, setTab] = useState(0)
	const [vendorData, setVendorData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [exportingData, setExportingData] = useState([]);

	// let safedata = Array.isArray(data?.data) ? data?.data : []

	const {
		vendorRef,
		dataTable,
		serviceData,
		handleSubmitVendor,
		currentPage,
		// } = useFilter(safedata, itemsPerPage);
	} = useFilter(vendorData, itemsPerPage);

	// useEffect(() => {
	// 	if (safedata.length !== 0) {
	// 		setItemsPerPage(safedata.length);
	// 	}
	// }, [safedata]);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	const handleTabChange = (event, newValue) => {
		setTab(newValue);
	};

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
			(perm) => perm.id_tab === 'vendor list' && perm.view === 1
		);

	const hideDelete = isAdmin
		? true
		: adminInfo?.permission?.some(
			(perm) => perm.id_tab === 'vendor list' && perm.delete === 1
		);

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
			(perm) => perm.id_tab === 'vendor list' && perm.edit === 1
		);

	const hideAdd = isAdmin
		? true
		: adminInfo?.permission?.some(
			(perm) => perm.id_tab === 'vendor list' && perm.add === 1
		);

	const hideExport = isAdmin
		? true
		: adminInfo?.permission?.some(
			(perm) => perm.id_tab === 'vendor list' && perm.export === 1
		);

	// useEffect(() => {
	// 	if (data?.status) {
	// 		setStatus(data.status);
	// 	} else {
	// 		setStatus(false);
	// 	}
	// }, [data?.status]);

	useEffect(() => {
		const fetchVendor = async () => {
			setLoading(true);
			try {
				let response;
				if (tab === 0) {
					response = await VendorServices.getAllVendor(1);
				} else if (tab === 1) {
					response = await VendorServices.getAllVendor(2);
				}
				const updatedData = response?.data || []
				// response?.data?.map(
				// 	({
				// 		id,
				// 		vendor_id,
				// 		vehicle_name_id,
				// 		vehicle_reg_no,
				// 		year_of_vehicle_manufactured,
				// 		...rest
				// 	}) => ({
				// 		id,
				// 		vendor_id,
				// 		vehicle_name_id: vehicle_name_id,
				// 		vehicle_reg_no: vehicle_reg_no,
				// 		year_of_vehicle_manufactured: year_of_vehicle_manufactured,
				// 		...rest,
				// 	})
				// ) || [];


				setVendorData(updatedData);
				setStatus(response?.status);

				const finalData = response?.data?.map((item, index) => {
					return {
						"SI.No": index + 1,
						"Vendor Ref.No": item.reference_no,
						"Vendor Name": item.company_name,
						"Email": item.email,
						"Contact No": item.contact_no,
						"Alternative No": item.al_contact_no || "-",
						"Address": item.address,
						"Pincode": item.pincode,
						"Destination": item.destination,
						"City/State": item.city,
						"Authorized Person": item.authorized_person,
						"Proof Type": item.proof_type,
						"Name in Proof": item.name_in_proof,
						"Proof ID Number": item.id_proof,
						"Pan No": item.pan_no,
						"Company Type": item.company_type,
						"Account No": item.account_no,
						"IFSC Code": item.ifsc_code,
						"Beneficiary Name": item.beneficiary_name,
						"Services Eligible": item.service_type,
						"Refered By": item.refered_by,
					};
				});

				setExportingData(finalData);
			} catch (error) {
				console.error('Error fetching vehicle:', error);
				setError(true);
			} finally {
				setLoading(false);
			}
		};
		fetchVendor();
		setIsUpdate(false);
	}, [tab, isUpdate]);

	// const updatedData = data?.data?.map((item, index) => {
	// 	return {
	// 		"SI.No": index + 1,
	// 		"Vendor Ref.No": item.reference_no,
	// 		"Vendor Name": item.company_name,
	// 		"Email": item.email,
	// 		"Contact No": item.contact_no,
	// 		"Alternative No": item.al_contact_no || "-",
	// 		"Address": item.address,
	// 		"Pincode": item.pincode,
	// 		"Destination": item.destination,
	// 		"City/State": item.city,
	// 		"Authorized Person": item.authorized_person,
	// 		"Proof Type": item.proof_type,
	// 		"Name in Proof": item.name_in_proof,
	// 		"Proof ID Number": item.id_proof,
	// 		"Pan No": item.pan_no,
	// 		"Company Type": item.company_type,
	// 		"Account No": item.account_no,
	// 		"IFSC Code": item.ifsc_code,
	// 		"Beneficiary Name": item.beneficiary_name,
	// 		"Services Eligible": item.service_type,
	// 		"Refered By": item.refered_by,
	// 	};
	// });

	const handleRefresh = () => {
		setIsUpdate(true);
	};

	const getTabName = () => {
		if (tab === 0) return "Unverified";
		if (tab === 1) return "All";
		return "";
	};

	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />
					<MainDrawer>
						<VendorDrawer id={serviceId} />
					</MainDrawer>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={vendorRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitVendor}
									/>
								</div>

								{hideAdd && (
									<div className="w-56">
										<Button
											onClick={toggleDrawer}
											className="w-full rounded-md h-10"
										>
											<span className="mr-3">
												<FiPlus />
											</span>
											Add Vendor
										</Button>
									</div>
								)}

								{hideExport && (
									<div className="items-center">
										<ExportDataXlsx
											title="Vendor"
											id_employee={adminInfo.id}
											// exportDataXlsx={updatedData}
											exportDataXlsx={exportingData}
											fileNames={`Vendor List_${getTabName()}`}
										/>
									</div>
								)}

								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>
					{functionLoading && <Loader message="Please wait..." />}
					<Tabs
						value={tab}
						onChange={handleTabChange}
						TabIndicatorProps={{
							style: { backgroundColor: '#057a55' },
						}}
						sx={{
							'& .MuiTab-root': {
								textTransform: 'capitalize',
							},
						}}
					>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Unverified"
						/>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="All"
						/>
					</Tabs>
					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer className="mb-8">
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
											<tr>
												<TableCell>Sl.No.</TableCell>
												<TableCell>Vendor Ref No.</TableCell>
												<TableCell>Vendor Name </TableCell>
												<TableCell>Franchise Partner Name </TableCell>
												<TableCell>City, State</TableCell>
												<TableCell>Authorized Person </TableCell>
												<TableCell>Contact No </TableCell>
												{tab == 0 && <TableCell>Changes</TableCell>}
												{tab == 0 && <TableCell>Action</TableCell>}
												{tab == 1 && <TableCell>Status </TableCell>}
												<TableCell>remark</TableCell>
												<TableCell className="text-center">Actions</TableCell>
											</tr>
										</TableHeader>
										<VendorTable
											vendor={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											hideDelete={hideDelete}
											hideEdit={hideEdit}
											tab={tab}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Vendors." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default Vendor;
